/* eslint-disable no-console */
import { captureException } from '@sentry/vue'
import { shouldLogError } from '~/utils/error-handling'

export type SentryLogger = typeof captureException
export type SentryLoggerParams = Parameters<SentryLogger>

type LoggerOptions<E> = {
  formatError?: (e: E) => unknown
  additionalData?: SentryLoggerParams[1]
}

/**
 * CLIENT ONLY logger
 * (DO NOT USE in `server/` folder, use `event.context.$sentry` instead)
 */
export const logger = {
  error: <E>(
    e: E,
    { additionalData, formatError }: LoggerOptions<E> = {},
  ): void => {
    // This gives us ability to format error for Sentry before logging it
    // for example - formatError function could be:
    // (originalError) => new Error(yourErrorMessage, { cause: originalError })
    const formattedError: unknown = formatError ? formatError(e) : e

    if (!shouldLogError(e)) {
      return
    }

    const runtimeConfig = useRuntimeConfig()
    const isDevelopment =
      runtimeConfig.public.sentry.environment === 'development'

    if (isDevelopment) {
      additionalData
        ? console.error(formattedError, additionalData)
        : console.error(formattedError)
    }

    additionalData
      ? captureException(formattedError, additionalData)
      : captureException(formattedError)
  },
}
